import React from 'react';
import PropTypes from 'prop-types';

function DeleteIcon({ color = 'black', width = 14, height = 15, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66732 2.16634V0.833008H10.334V2.16634H13.6673V3.49967H12.334V13.4997C12.334 13.6765 12.2637 13.8461 12.1387 13.9711C12.0137 14.0961 11.8441 14.1663 11.6673 14.1663H2.33398C2.15717 14.1663 1.9876 14.0961 1.86258 13.9711C1.73756 13.8461 1.66732 13.6765 1.66732 13.4997V3.49967H0.333984V2.16634H3.66732ZM3.00065 3.49967V12.833H11.0007V3.49967H3.00065ZM5.00065 5.49967H6.33398V10.833H5.00065V5.49967ZM7.66732 5.49967H9.00065V10.833H7.66732V5.49967Z"
        fill={color}
      />
    </svg>
  );
}

DeleteIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default DeleteIcon;
